export default function Numpy_Exercises() {
  return <div>Numpy_Exercises Component</div>;
}
